import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Bookmark.svg",
  "use": "Bookmark.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Bookmark.svg\"><path d=\"M17.01,54.01v-42.98a3,3,0,0,1,3-3h24a3,3,0,0,1,3,3V54.01a2,2,0,0,1-2.997,1.7339L32.509,49.1282a1,1,0,0,0-.997,0L20.0074,55.7435A2,2,0,0,1,17.01,54.01Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol